import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSystemThemeLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "system-theme-light-icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
			id: "stl-cut",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			}), /* @__PURE__ */ _jsx("rect", {
				x: 13.16,
				y: 13.64,
				width: 9.6,
				height: 6.72,
				rx: 1.44,
				fill: "black"
			})]
		}) }),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#stl-cut)",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(10.5 10.5) scale(0.85) translate(-12 -12)",
				children: [
					/* @__PURE__ */ _jsx("circle", {
						cx: 12,
						cy: 12,
						r: 4
					}),
					/* @__PURE__ */ _jsx("path", { d: "M12 2v2" }),
					/* @__PURE__ */ _jsx("path", { d: "M12 20v2" }),
					/* @__PURE__ */ _jsx("path", { d: "m4.93 4.93 1.41 1.41" }),
					/* @__PURE__ */ _jsx("path", { d: "M2 12h2" }),
					/* @__PURE__ */ _jsx("path", { d: "M20 12h2" }),
					/* @__PURE__ */ _jsx("path", { d: "m6.34 17.66-1.41 1.41" }),
					/* @__PURE__ */ _jsx("path", { d: "m19.07 4.93-1.41 1.41" })
				]
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			transform: "translate(12.2 12.2) scale(0.48)",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 18,
				height: 12,
				x: 3,
				y: 4,
				rx: 2
			}), /* @__PURE__ */ _jsx("path", { d: "M2 20h20" })]
		})
	]
});
export default SvgSystemThemeLight;
